import { render, staticRenderFns } from "./SiteViolationReport.vue?vue&type=template&id=b97cb450&scoped=true&"
import script from "./SiteViolationReport.vue?vue&type=script&lang=js&"
export * from "./SiteViolationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97cb450",
  null
  
)

export default component.exports